module.exports = __webpack_public_path__ + "img/bg-vhub-login.jpg.bak.dbcf7634.jpg";